.address {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
}

.more {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
}

.moreHeading {
  margin: 0;
  font-size: var(--text-sm);
}

.moreTrigger {
  display: inline-flex;
  align-items: center;
  gap: var(--space-1);
  padding: var(--space-1) 0;
  border: 0;
  background: none;
  color: var(--color-link);
  font-weight: var(--weight-semibold);
  cursor: pointer;
}

.moreChevron {
  transition: transform var(--duration-fast) var(--ease-out);
}

.more[data-expanded] .moreChevron {
  transform: rotate(180deg);
}
